// Imports

const { log } = require('./std/index');
const { initWidget } = require('./widgets/index');
const { initSlice } = require('./slices/index');
const { initController } = require('./controllers/index');


//
// DOM Ready
//

$(document).ready(() => {
  console.log('Main app: Starting initialization...');

  // Invoke widgets
  $('[data-widget]').each(initWidget);

  // Invoke slices
  $('[data-slice]').each(initSlice);

  // Invoke controllers
  $('[data-controller]').each(initController);

  // Manually invoke global controllers
  initController(0, $('body'), 'lightbox');

  console.log('Main app: Initialization complete');
});


//
// Global behaviour
//

// Fancy log
const year = (new Date()).getFullYear();
const color = (it) => "color: " + it + ";";

const green = color('#afbd21');
const black = color('#000000');
const blue = color('#5474a8');

log(`%c© %cThe Casing Boutique%c and %cGHOST STREET%c, ${year}. %c[https://ghost.st]`, black, green, black, blue, black, blue);